<template>
	<div class="health_home">
		<!--患者列表-->
		<!-- <HomePatientList ref="homePatientList" @clickSelect="getPatient" /> -->
		<!--患者基础信息-->
		<HomePatientBase type="homeStyle" />
		<!-- <HomePatientBase
			type="homeStyle"
			toggleArchiveType="button"
			actionClass="patient_button_style"
			:id="info.id"
			:show-toggle-archive="info.patientNum"
			:archive-dot="info.otherPatientStatus"
			:avatar="info.avatar"
			:status="info.approveStatus"
			@toggleArchive="$refs.homePatientList.init(info.id)"
		/> -->
		<base-card title="健康工具" class="mt-28">
			<van-grid :column-num="5" class="tools_grid" :border="false">
				<van-grid-item v-for="(item,index) in buttonCardList" :key="index" :to="item.to">
					<van-badge :dot="item.dot">
						<div class="tools_grid__icon">
							<img
								class="tools_grid__icon__inner"
								:src="require(`@/assets/icon/icon_my_home_${item.icon}.png`)"
								alt=""
							/>
						</div>
					</van-badge>
					<span class="tools_grid__text">{{item.name}}</span>
				</van-grid-item>
			</van-grid>
		</base-card>
		<base-card class="indicator_card mt-28" title="指标记录">
			<div class="indicator_card_row">
				<van-row gutter="8">
					<van-col span="12">
						<HomeIndicatorItem
							title="血压"
							:status="getBloodPresureState"
							:record-time="info.bloodPressureDate"
							@click="$router.push(`/indicator/bloodPressure`)"
						>
							<div class="indicator_inner">
								<h2 class="value">
									{{ info.highPressure }}/{{ info.lowPressure}}
									<span class="value_unit">mmHg</span>
								</h2>
							</div>
						</HomeIndicatorItem>
					</van-col>
					<van-col span="12">
						<HomeIndicatorItem
							title="血糖"
							:status="info.bloodSugarStatus"
							:record-time="info.bloodSugarDate"
							@click="$router.push(`/indicator/bloodSugar`)"
						>
							<div class="indicator_inner">
								<h2 class="value">
									{{ info.bloodSugar }}
									<span class="value_unit">mmol/L</span>
								</h2>
								<p class="nodes">{{ $status.bloodSugarType[info.sugarType] }}</p>
							</div>
						</HomeIndicatorItem>
					</van-col>
					<van-col span="24" class="mt-16">
						<HomeIndicatorItem
							title="血脂"
							:record-time="info.bloodLipidsDate"
							@click="$router.push(`/indicator/bloodFat`)"
						>
							<div style="display:flex">
								<div class="indicator_inner">
									<h2 class="value">
										{{ info.triglycerides }}
										<span class="value_unit">mmol/L</span>
										<span class="value_tag" :class="$status.bloodStatus[info.triglyceridesStatus]">
											{{$status.bloodStatusStr[$status.bloodStatus[info.triglyceridesStatus]]}}
										</span>
									</h2>
									<p class="nodes">甘油三酯</p>
								</div>
								<div class="indicator_inner">
									<h2 class="value">
										{{ info.lowDensityFat }}
										<span class="value_unit">mmol/L</span>
										<span class="value_tag" :class="$status.bloodStatus[info.lowDensityFatStatus]">
											{{$status.bloodStatusStr[$status.bloodStatus[info.lowDensityFatStatus]]}}
										</span>
									</h2>
									<p class="nodes">低密度脂蛋白胆固醇</p>
								</div>
							</div>
						</HomeIndicatorItem>
					</van-col>
				</van-row>
			</div>
		</base-card>
		<base-card title="诊疗记录" class="mt-28">
			<van-row gutter="16">
				<van-col :span="8">
					<div class="cure_item" @click="clickGoMedical">
						<img src="@/assets/icon/icon_home_cure_2.png" alt="就医记录" title="就医记录" />
						<div>就医记录</div>
					</div>
				</van-col>
				<van-col :span="8">
					<div style="background-color:#EBF6FF" class="cure_item" @click="clickGoInspection">
						<img src="@/assets/icon/icon_home_cure_3.png" alt="检验记录" title="检验记录" />
						<div>检验记录</div>
					</div>
				</van-col>
				<van-col :span="8">
					<div class="cure_item cure_item__info" @click="clickGoPhysical">
						<img src="@/assets/icon/icon_home_cure_4.png" alt="体检记录" title="体检记录" />
						<div>体检记录</div>
					</div>
				</van-col>
			</van-row>
		</base-card>
	</div>
</template>

<script>
import HomePatientBase from '../main/components/patient-base.vue'
import HomeIndicatorItem from './components/home-indicator-item.vue'

export default {
    name: 'health_home',
    components: { HomePatientBase, HomeIndicatorItem },
    data: () => ({}),
    computed: {
        info () {
            return this.$store.getters['account/patientInfo']
        },
        // 获取血压状态
        getBloodPresureState () {
            return Math.max(this.info.highPressureStatus, this.info.lowPressureStatus)
        },
        buttonCardList () {
            const { id, messageNumber } = this.info
            return [
                { name: '复发评估', icon: '2', to: `/risk/add/${id}` },
                { name: '随访记录', icon: '11', to: `/followUp/list/${id}` },
                { name: '复诊计划', icon: '12', to: `/plan/list/${id}` },
                { name: '健康报告', icon: '15', to: `/report/list/${id}` },
                { name: '医生消息', icon: '13', to: `/message/list/${id}`, showDot: true, dot: messageNumber },
                { name: '用药信息', icon: '14', to: `/health/medication/list/${id}` }
            ]
        }
    },
    activated () {
        console.log('activated===到这里了')
    },
    mounted () {
        this.$store.dispatch('account/actionGetDateTime')
        // this.getPatient({ id: this.$store.getters['account/getPatientId'] })
    },
    methods: {
        getPatient ({ id, type }) {
            const _this = this
            this.$store.dispatch('account/actionSwitchPatient', {
                params: id,
                callback: () => {
                    if (type === 'toggle') {
                        _this.$toast.success('档案切换成功')
                    }
                }
            })
        },
        clickGoMedical () {
            if (this.info.hospitalVisitCount) {
                this.$router.push(`/health/medical/list/${this.info.id}`)
            } else {
                this.$router.push(`/health/medical/edit/${this.info.id}?source=home`)
            }
        },
        clickGoInspection () {
            if (this.info.inspectionCount) {
                this.$router.push(`/health/inspection/list/${this.info.id}`)
            } else {
                this.$router.push(`/health/inspection/edit/${this.info.id}?source=home`)
            }
        },
        clickGoPhysical () {
            if (this.info.physicalExaminationCount) {
                this.$router.push(`/health/physical/list/${this.info.id}`)
            } else {
                this.$router.push(`/health/physical/edit/${this.info.id}?source=home`)
            }
        },
    }
};
</script>

<style scoped lang="less">
.health_home {
	padding: 30px 28px 10px 28px;
	background: linear-gradient(180deg, #05c0ca 28%, rgba(28, 193, 202, 0) 100%);
	background-size: 100vw 526px;
	background-repeat: no-repeat;
	.patient_name {
		> span {
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: @gray-9;
			margin-left: 5px;
		}
	}

	.indicator_card {
		.indicator_inner {
			flex: 1;
			.value {
				font-family: PingFangSC-Semibold;
				font-size: 36px;
				font-weight: normal;
				color: #1f2329;
				vertical-align: bottom;
				.value_unit {
					font-family: PingFangSC-Regular;
					font-size: 24px;
					font-weight: normal;
				}
				.value_tag {
					color: #ffffff;
					display: inline-block;
					font-size: 24px;
					border-radius: 4px;
					padding: 0 8px;
					margin-left: 12px;
					&.high {
						background-color: @danger;
					}
					&.normal {
						background-color: @primary;
					}
					&.low {
						background-color: @info;
					}
				}
			}
			.nodes {
				font-family: PingFangSC-Regular;
				font-size: 20px;
				font-weight: normal;
				color: #8f959e;
			}
			.unit {
				font-family: PingFangSC-Regular;
				font-size: 24px;
				font-weight: normal;
				color: #1f2329;
			}
		}
	}
	.cure_item {
		text-align: center;
		border-radius: 16px;
		background-color: #e3f8fa;
		font-size: 30px;
		color: #1f2329;
		padding: 28px 0;
		font-weight: bold;
		img {
			width: 80px;
			height: 80px;
		}
	}
}
</style>

<style lang="less">
.health_home {
	.patient_button_style {
		border: 1px solid #dee0e3;
		padding: 4px 16px;
		border-radius: 22px;
	}
}
</style>
